import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { Credentials, LoginContext } from './authentication.service';

export class MockAuthenticationService {

  credentials: Credentials | null = {
    username: 'test@test.com',
    accessToken: 'test',
    refreshToken: 'refresh',
    expiresAt: 123
  };

  login(context: LoginContext): Observable<Credentials> {
    return of({
      username: 'test@test.com',
      accessToken: 'test',
      refreshToken: 'refresh',
      expiresAt: 123
    });
  }

  logout(): Observable<boolean> {
    this.credentials = null;
    return of(true);
  }

  isAuthenticated(): boolean {
    return !!this.credentials;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/authentication/authentication.service.mock.ts